import React from 'react';
import ProjectQuoteInvoice from './../../ProjectQuoteInvoice';

const ProjectPlanTab = ({ SelectedBrief, SelectedProfessional, IsInfoEdit ,getUpdated}) => {
 
    return (
        <div className='BriefInfoSection' style={{ padding: '0% 1%' }}>
            <ProjectQuoteInvoice 
                Brief={SelectedBrief} 
                SelectedPro={SelectedProfessional} 
                isEditProjectPlan={IsInfoEdit} 
                getUpdated={getUpdated} 
            />
        </div>
    );
};

export default ProjectPlanTab;